<template>
	<div class="page h100 overA" v-loading="loading">
		<el-row :gutter="20" style="margin-top: 20px;">
			<el-col :span="12">
				<div>
					<el-button v-if="time" :type="time[0] === today[0] && time[1] === today[1] ? 'primary' : ''"
						@click="toDay">今日</el-button>
					<el-button v-if="time" :type="time[0] === month[0] && time[1] === month[1] ? 'primary' : ''"
						@click="toMonth">本月</el-button>
					<el-date-picker class="mgl10" v-model="time" type="datetimerange" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss"
						@change="queryData">
					</el-date-picker>
				</div>
			</el-col>
			<el-col :span="12">
				<div v-if="!hasLYConfirm&&LYflag">
					<i class="el-icon-warning-outline" style="margin-right: 5px;"></i>重点通知：<span
						class="lyConfirmBtn" @click="handleShowLYrule">履约确认</span></div>
			</el-col>
		</el-row>
		<div>
			<el-row :gutter="20" style="margin-top: 20px;">
				<el-col :span="12">
					<el-card shadow="never" class="card-xse">
						<h3 slot="header" class="flex flex-center flex-sb">
							<span>销售额</span>
							<span class="time" v-if="time">{{ time[0] === today[0] && time[1] === today[1] ? "今" : time.join(" - ")
							}}日数据</span>
						</h3>
						<template v-if="supGmv">
							<div class="flex flex-baseline">
								<span class="number">¥{{ supGmv.amount }}</span>
								<div class="rate mgl10" :style="{ 'color': supGmv.amountRate < 0 ? 'green' : 'red' }">环比{{
									supGmv.amountRate
								}}%</div>
							</div>
							<p class="time mgt10">（包含退款）</p>
						</template>
						<div ref="echarts1" style="width: 100%; height: 250px;"></div>
						<p class="msg mgt10">*此趋势图为近31天的销售数据</p>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card shadow="never" class="pointer card-dxp">
						<h3 slot="header" class="flex flex-center flex-sb">
							<span>动销品</span>
							<span class="time" v-if="time">{{ time[0] === today[0] && time[1] === today[1] ? "今" : time.join(" - ")
							}}日数据</span>
						</h3>
						<div v-if="supGmv" @click="goOnSaleProduct" class="flex flex-baseline">
							<div class="number">{{ supGmv.spuCount }}</div>
							<div class="rate mgl10" :style="{ 'color': supGmv.spuCountRate < 0 ? 'green' : 'red' }">环比{{
								supGmv.spuCountRate
							}}%</div>
						</div>
						<div @click="goOnSaleProduct" ref="echarts2" style="width: 100%; height: 250px;"></div>
						<p class="msg mgt10">*此趋势图为近31天的动销数据</p>
					</el-card>
				</el-col>
			</el-row>
			<el-row :gutter="20" style="margin-top: 20px;">
				<el-col :span="12">
					<el-card shadow="never" class="pointer">
						<h3 slot="header">超时发货预警</h3>
						<div v-if="shipRankingList.timeIn2448CountRate > 0">
							<div style="color:#FE9604 ;" v-if="shipRankingList.timeIn2448CountRate > 90">
								恭喜！您近期发货时效位于平台前20%，商品将优先展示给更多买家，享受高流量曝光。请继续保持！
							</div>
							<div style="color:#FE9604 ;" v-else-if="shipRankingList.timeIn2448CountRate < 70">
								预警！您近期发货时效位于平台后20%，请尽快调整在架商品，以免影响商品展示，避免不必要的下架整改。请尽快调整！
							</div>
							<div style="color:#FE9604 ;" v-else>
								注意！您近期发货时效位于平台前50%，请关注发货时效低产品，提升后将获得更多平台流量与曝光支持。请继续提升！
							</div>
						</div>
						<div class="mgt10" v-if="unShipmentCount">
							<div class="flex">
								<div @click="goOrder(1)" class="order1 flex-1">
									<div class="order1-p1">24h内</div>
									<p class="order1-p2 mgl10 mgt10">未发货订单 / 已发货订单</p>
									<p class="flex flex-baseline mgl10 mgt10 mgb10">
										<span class="order1-p3">{{ unShipmentCount.unShipIn24Num }}/</span>
										<span class="order1-p2">{{ shipRankingList.timeIn24Count }}</span>
									</p>
								</div>
								<div @click="goOrder(2)" class="order2 flex-1 mgl10">
									<div class="order1-p1">超24h</div>
									<p class="order1-p2 mgl10 mgt10">未发货订单 / 已发货订单</p>
									<p class="flex flex-baseline mgl10 mgt10 mgb10">
										<span class="order1-p3">{{ unShipmentCount.unShip2448Num }}/</span>
										<span class="order1-p2">{{ shipRankingList.timeIn2448Count }}</span>
									</p>
								</div>
							</div>
							<div class="flex mgt10">
								<div @click="goOrder(3)" class="order3 flex-1">
									<div class="order3-p1">超48h</div>
									<p class="order3-p2 mgl10 mgt10">未发货订单 / 已发货订单</p>
									<p class="flex flex-baseline mgl10 mgt10 mgb10">
										<span class="order3-p3">{{ unShipmentCount.unShip4872Num }}/</span>
										<span class="order3-p2">{{ shipRankingList.timeIn4872Count }}</span>
									</p>
								</div>
								<div @click="goOrder(4)" class="order4 flex-1 mgl10">
									<div class="order3-p1">超72h</div>
									<p class="order3-p2 mgl10 mgt10">未发货订单 / 已发货订单</p>
									<p class="flex flex-baseline mgl10 mgt10 mgb10">
										<span class="order3-p3">{{ unShipmentCount.unShipOut72Num }}/</span>
										<span class="order3-p2">{{ shipRankingList.timeInOut72Count }}</span>
									</p>
								</div>
							</div>
						</div>
						<div class="znfx flex flex-center flex-sb">
							<div>
								<span class="znfx-p1">智能分析</span>
								<span class="znfx-p2 mgl10">发货时效最差TOP5商品</span>
							</div>
							<el-radio-group v-model="shipRankingListTimeType" @input="getShipRankingList" size="medium">
								<el-radio-button :label="7">近7天</el-radio-button>
								<el-radio-button :label="30">近30天</el-radio-button>
								<el-radio-button :label="90">近90天</el-radio-button>
							</el-radio-group>
						</div>
						<el-table :data="shipRankingList.list" style="width: 100%;" border class="pointer mgt20"
							:header-cell-style="{ 'text-align': 'center', 'background': '#F0F4FC' }" @row-click="goProductDetail"
							:cell-style="{ 'text-align': 'center' }" :row-style="rowStyle">
							<!-- <el-table-column prop="spuName" label="商品名称"></el-table-column> -->
							<el-table-column prop="modelCode" label="型号"></el-table-column>
							<el-table-column prop="shipCount" label="发货台数"></el-table-column>
							<el-table-column label="状态">
								<template slot-scope="scope">
									{{ scope.row.isShelves ? "上架" : "下架" }}
								</template>
							</el-table-column>
						</el-table>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card shadow="never" class="pointer">
						<h3 slot="header" class="flex flex-center flex-sb">
							<p>退货率</p>
							<el-radio-group v-model="allAfterTimeType" @input="getAfterCount" size="medium">
								<el-radio-button :label="30">近30天</el-radio-button>
								<el-radio-button :label="7">近7天</el-radio-button>
							</el-radio-group>
						</h3>
						<div @click="goAfterSale">
							<div class="allAfter-item flex flex-center">
								<el-progress type="circle" :percentage="afterCount.allAfterCountRate" :stroke-width="20" color="#F74644"
									:width="150"></el-progress>
								<div class="mgl20">
									<p class="allAfter-item-p1">总退货率</p>
									<p class="allAfter-item-p2">{{ afterCount.allAfterCountRate }}%</p>
								</div>
							</div>
							<div class="allAfter-item mgt10 flex">
								<div class="flex-1 flex flex-center">
									<el-progress type="circle" :percentage="afterCount.userAfterCountRate" :stroke-width="10"
										color="#3B6FFA" :width="80"></el-progress>
									<div class="mgl20">
										<p class="allAfter-item-p1" style="font-size:18px ;">主动退货率</p>
										<p class="allAfter-item-p2" style="font-size:32px ;">{{ afterCount.userAfterCountRate }}%</p>
									</div>
								</div>
								<div class="flex-1 flex flex-center">
									<el-progress type="circle" :percentage="afterCount.otherAfterCountRate" :stroke-width="10"
										color="#0CC1C5" :width="80"></el-progress>
									<div class="mgl20">
										<p class="allAfter-item-p1" style="font-size:18px ;">非客户原因退货率</p>
										<p class="allAfter-item-p2" style="font-size:32px ;">{{ afterCount.otherAfterCountRate }}%</p>
									</div>
								</div>
							</div>
							<!-- <div class="flex">
								<div class="flex-1 flex flex-center flex-jc" style="font-size: 40px;color:rgb(88 217 249);">
									<template v-if="afterCount">总退货率{{ afterCount.allAfterCountRate
										}}%</template>
								</div>
								<div class="flex-1">
									<div ref="echarts3" style="width: 100%; height: 250px;"></div>
								</div>
							</div>
							<div class="flex">
								<div class="flex-1">
									<div ref="echarts4" style="width: 100%; height: 200px;"></div>
								</div>
								<div class="flex-1">
									<div ref="echarts5" style="width: 100%; height: 200px;"></div>
								</div>
							</div> -->
						</div>
						<div class="znfx flex flex-center">
							<span class="znfx-p1">智能分析</span>
							<span class="znfx-p2 mgl10">非客户原因退货TOP5商品</span>
						</div>
						<el-table :data="afterCount ? afterCount.list : []" style="width: 100%;" border class="pointer mgt20"
							:header-cell-style="{ 'text-align': 'center', 'background': '#F0F4FC' }" @row-click="goProductDetail"
							:cell-style="{ 'text-align': 'center' }" :row-style="rowStyle">
							<!-- <el-table-column prop="spuName" label="商品名称"></el-table-column> -->
							<el-table-column prop="modelCode" label="型号"></el-table-column>
							<el-table-column prop="afterCount" label="售后台数"></el-table-column>
							<el-table-column label="状态">
								<template slot-scope="scope">
									{{ scope.row.isShelves ? "上架" : "下架" }}
								</template>
							</el-table-column>
						</el-table>
					</el-card>
				</el-col>
			</el-row>
			<el-row :gutter="20" style="margin-top: 20px;">
				<el-col :span="12">
					<el-card shadow="never">
						<h3 slot="header" class="flex flex-center flex-sb">
							<span>商品浏览</span>
							<span class="time" v-if="time">{{ time[0] === today[0] && time[1] === today[1] ? "今" : time.join(" - ")
							}}日数据</span>
						</h3>
						<div class="flex" v-if="productViewCount">
							<div class="flex-1 flex">
								<img src="https://homeimage.ksaxshop.com/%E7%BC%96%E7%BB%84%2022.png" alt="" style="width:60px;">
								<div class="flex-1 flex flex-col flex-sb mgl10">
									<p class="productView-p1">商品浏览量</p>
									<p class="productView-p2">{{ productViewCount ? productViewCount.allViewCount : "" }}</p>
								</div>
							</div>
							<div class="flex-1 flex">
								<img src="https://homeimage.ksaxshop.com/%E7%BC%96%E7%BB%84%2023.png" alt="" style="width:60px;">
								<div class="flex-1 flex flex-col flex-sb mgl10">
									<p class="productView-p1">商品浏览转化率</p>
									<p class="productView-p2">{{ productViewCount ? `${productViewCount.allViewCountRate}%` : "" }}</p>
								</div>
							</div>
						</div>
						<div class="znfx flex flex-center flex-sb">
							<div>
								<span class="znfx-p1">智能分析</span>
								<span class="znfx-p2 mgl10">商品浏览转化率明细</span>
							</div>
							<el-radio-group v-model="form.productViwSort" @input="getProductViewCount" size="medium">
								<el-radio-button :label="0">浏览量排序</el-radio-button>
								<el-radio-button :label="1">浏览转化率排序</el-radio-button>
							</el-radio-group>
						</div>
						<el-table :data="productViewCount ? productViewCount.list : []" style="width: 100%" border
							class="pointer mgt20" :header-cell-style="{ 'text-align': 'center', 'background': '#F0F4FC' }"
							@row-click="goProductDetail" :cell-style="{ 'text-align': 'center' }" :row-style="rowStyle">
							<!-- <el-table-column prop="proName" label="商品名称"></el-table-column> -->
							<el-table-column prop="modelCode" label="型号"></el-table-column>
							<!-- <el-table-column prop="price" label="销售价"></el-table-column>
							<el-table-column label="最低销售价">
								<template slot-scope="scope">
									{{ scope.row.lowPrice ? scope.row.lowPrice : "暂无" }}
								</template>
							</el-table-column> -->
							<el-table-column prop="billPrice" label="供货价"></el-table-column>
							<el-table-column prop="viewCount" label="浏览量">
							</el-table-column>
							<el-table-column label="浏览转化率">
								<template slot-scope="scope">
									{{ scope.row.spuRate }}%
								</template>
							</el-table-column>
						</el-table>
						<el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="form.pageIndex" :page-sizes="[10, 20, 30, 40, 50]" :page-size="form.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="productViewCount ? productViewCount.dataCount : 0">
						</el-pagination>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card shadow="never">
						<h3 slot="header" class="flex flex-center flex-sb">
							<span>销量榜</span>
							<span class="time" v-if="time">{{ time[0] === today[0] && time[1] === today[1] ? "今" : time.join(" - ")
							}}日数据</span>
						</h3>
						<ul class="flex flex-wp" style="margin-top: -10px;margin-left:-10px">
							<li class="mgl10 mgt10" v-for="(item, index) in productTypeCount ? productTypeCount.typeList : []"
								:key="item.typeId" @click="typeClick(item)">
								<el-tag style="border-radius: 100px;" :effect="item.typeId === saleForm.typeId ? 'dark' : 'plain'"
									class="pointer">{{
										item.typeName
									}}</el-tag>
							</li>
						</ul>
						<el-table :data="productSpuPankErpCount ? productSpuPankErpCount.spuList : []" style="width: 100%" border
							class="mgt20 pointer" :header-cell-style="{ 'text-align': 'center', 'background': '#F0F4FC' }"
							:cell-style="{ 'text-align': 'center' }" @row-click="goProductDetail" :row-style="rowStyle">
							<!-- <el-table-column prop="proName" label="商品名称">
							</el-table-column> -->
							<el-table-column prop="spuId" label="商品ID">
							</el-table-column>
							<el-table-column prop="modelCode" label="型号">
							</el-table-column>
							<el-table-column prop="orderCount" label="销量">
							</el-table-column>
						</el-table>
						<el-pagination class="pagination" @size-change="handleSaleSizeChange"
							@current-change="handleSaleCurrentChange" :current-page="saleForm.pageIndex"
							:page-sizes="[10, 20, 30, 40, 50]" :page-size="saleForm.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="productSpuPankErpCount ? productSpuPankErpCount.dataCount : 0">
						</el-pagination>
					</el-card>
				</el-col>
			</el-row>
			<div style="height: 20px;"></div>
			<!--  -->
			<!-- <el-dialog title="公告" :visible.sync="announcementVisible1" width="50%" :close-on-click-modal="false"
				:close-on-press-escape="false" :show-close="false">
				<p>尊敬的合作伙伴，</p>
				<p class="p">
					在2024财年，营客通平台为进一步提升厨卫、生活电器等核心品类的市场份额与客户忠诚度，已在流量导入、主打品类推广及优化客户购买流程等方面加大了营销资源与成本投入，这一系列举措已经带动了相关品类数据的稳健增长，并获得了市场的积极反馈。
				</p>
				<p class="p">
					为进一步巩固市场份额，激发客户复购热情。营客通平台决定自2024年3月19日开始，在集市板块针对厨卫和生活电器类商品交易，调整平台信息服务费率至5%，此举旨在平衡服务质量与商业激励，确保双方共同利益的最大化。
				</p>
				<p class="p">
					与此同时，为了表彰并鼓励在集市板块中销售上述品类且年度销售额达到我司设定标准的优质供应商伙伴，我们将设立一项基于销售规模的奖励机制。凡符合资格者，可详细了解相关奖励计划的具体条款及申请方式，请及时联系负责采销经理获取详情。
				</p>
				<p class="p">在此，我们衷心祝愿各位合作伙伴在新的一年里，商品销售如火如荼，业绩一路攀升，携手共创辉煌！</p>
				<p class="p">敬请留意官方公告，并提前做好相应的商业规划与调整，感谢您一直以来的信任与合作！</p>
				<span slot="footer">
					<el-button type="primary" @click="announcement1Close">知道了</el-button>
				</span>
			</el-dialog>
			<el-dialog :visible.sync="announcementVisible2" width="50%" :close-on-click-modal="false"
				:close-on-press-escape="false" :show-close="false">
				<div class="p2">
					<p class="textC red" style="font-size: 20px;padding-bottom:10px">关于规范收取供应商保证金的通知</p>
					<p>为了保证各供应商在营客通平台经营过程中遵守平台相关规定和承诺，以良好的信誉和服务质量更好的服务平台用户。根据营客通《商务合同》约定，现就平台供应商保证金收取通知如下：</p>
					<b>保证金收取标准：2000元。</b>
					<b>缴纳方式：在供应商待结算货款余额中扣除。</b>
					<b>缴纳时间：2024年7月12日前完成缴纳。</b>
					<p>新入驻供应商给予3个月0保证金的阶段性扶持，待当月交易额超5万或入驻时间达到90天予以收取。</p>
					<p>保证金是指供应商向营客通缴纳的，在供应商未履行消费者权益保障义务、违反服务协议或者“营客通平台”相关规则、流程时，用于对买家进行赔付或向买家支付违约金的资金，营客通可以依照双方签署的协议或平台规则进行处置。
					</p>
					<p>我们希望用更公平的规则去致力于双方的合作共赢、互惠互利，也期待未来与各供应商开展更深入合作。</p>
					<p class="textR red">上海赢可通信息科技有限公司</p>
					<p class="textR red">二0二四年七月九日 </p>
				</div>
				<span slot="footer">
					<el-button type="primary" @click="announcement2Close">知道了</el-button>
				</span>
			</el-dialog> -->
			<el-dialog :visible.sync="announcementVisible" width="60%" :close-on-click-modal="false"
				:close-on-press-escape="false" :show-close="false">
				<div class="p2">
					<p class="textC red" style="font-size: 22px;padding-bottom:10px;margin-top:0">关于营客通平台集市板块停止运营的通知</p>
					<b>尊敬的合作伙伴：</b>
					<p>感谢一直以来对营客通平台的支持与信任！为优化平台业务结构，集中资源提升客户体验，经平台慎重评估，我们决定将于 2025 年 6 月 24 日起正式停止【集市板块】的运营，现将相关安排通知如下：</p>
					<p><b>1、关闭时间：</b>【集市板块】将于 2025 年 7 月 15 日全面下线，届时板块内店铺的商品上下架、展示、交易、等功能将同步终止。</p>
					<p><b>2、后续处理：</b></p>
					<p><b>订单与售后：</b>关闭前产生的订单，请按平台规则正常履行发货、售后等义务。</p>
					<p>
						<b>费用结算：</b>已产生订单未结算款项，将在订单真实发货且物流签收后的每周二周五，按原流程完成结算。因店铺所售商品非一次性商品，可能存在退货、退款情况，无服务质保金的店铺，平台将暂扣2000元（如发生退货退款的金额，暂扣质保金不足的，需重新向平台打款），作为服务质保金，6个月后，给予返还。
					</p>
					<p><b>3、替代方案：</b>如您的商品、订单履约、售后服务等符合平台【自营板块】入驻条件，欢迎联系您的采销经理提交入驻申请。</p>
					<p>再次感谢您的理解与配合！营客通将持续为合作伙伴提供更广阔的平台，期待与您携手共进！</p>
					<p>特此通知。</p>
					<p class="textR red">上海赢可通信息科技有限公司</p>
					<p class="textR red">2025年6月24日 </p>
				</div>
				<span slot="footer">
					<el-button type="primary" @click="announcementClose">知道了</el-button>
				</span>
			</el-dialog>
			<!-- 履约规则 -->
			<el-dialog :visible.sync="lyRuleVisible" width="60%" :close-on-click-modal="false" :close-on-press-escape="false"
				:show-close="false">
				<div class="p2">
					<p>郑重承诺在与营客通平台合作期间，严格遵守“供应商入驻协议”及以下平台规则，并自愿接受平台管理与考核处罚：</p>
					<p>非客退货：非客户原因，因<span class="red">发货时效慢、下单区域无货</span>等引起的退货。</p>
					<p>非客退货率 = 非客退货订单数 ÷ 总订单数 × 100%</p>
					<p>1. 首月非客退货率＞10%：平台有权<span class="red">限制上架产品数量为 10 个以内</span>；</p>
					<p>2. 连续三个月非客退货率＞10%：平台有权<span class="red">所有产品下架，暂停合作</span>。</p>
				</div>
				<span slot="footer">
					<el-button type="primary" @click="handleSetLYrule">我知道了</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import {
	GetAllReseller,
	KSAXApiRequest
} from "@/api/api";
import echarts from 'echarts'
import applicationUserManager from "../Auth/applicationusermanager";
export default {
	name: "Welcome",
	data() {
		return {
			loading: false,
			loadingCount: 0,
			form: {
				supId: 0,
				typeId: 0,
				startTime: null,
				endTime: null,
				productViwSort: 0,
				pageIndex: 1,
				pageSize: 10
			},
			today: [this.$moment().format('YYYY-MM-DD'), this.$moment().add(1, 'd').format('YYYY-MM-DD')],
			// this.time = [this.$moment().format('YYYY-MM-DD 00:00:00'), this.$moment().format('YYYY-MM-DD 23:59:59')]
			month: [this.$moment().startOf('month').format('YYYY-MM-DD'), this.$moment().endOf('month').format('YYYY-MM-DD')],
			time: null,
			supGmv: null,
			unShipmentCount: null,
			saleSpuCount: null,
			afterCount: {},
			productViewCount: null,
			productTypeCount: null,
			productSpuPankErpCount: null,
			// announcementVisible1: false,
			// announcementVisible2: false,
			announcementVisible: false,
			allAfterTimeType: 30,
			shipRankingListTimeType: 7,
			shipRankingList: {},
			timeIn2448CountRate: 0,
			saleForm: {},
			LYflag: false,
			hasLYConfirm: false,
			lyRuleVisible: false,
		}
	},
	watch: {
		loadingCount(n, o) {
			if (n === 7) {
				this.loading = false
			}
		},
		time: {
			handler: function (n, o) {
				this.form.startTime = n ? n[0] : null;
				this.form.endTime = n ? n[1] : null;
			},
			deep: false,
			immediate: false
		},
	},
	mounted() {
		var curTime = new Date()
		if (window.localStorage.TokenExpire) {
			var expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
			if (curTime >= expiretime) {
				if (global.IS_IDS4) {
					applicationUserManager.login();
				} else {
					this.$router.push('/login');
				}
			}
		} else {
			if (global.IS_IDS4) {
				applicationUserManager.login();
			} else {
				this.$router.push('/login');
			}
		}
		// 公告
		// if (localStorage.getItem("announcement1") === null) {
		// 	this.announcementVisible1 = true
		// } else if (localStorage.getItem("announcement2") === null) {
		// 	this.announcementVisible2 = true
		// }
		if (localStorage.getItem("announcement") === null) {
			this.announcementVisible = true
		}
		GetAllReseller().then(res => {
			if (res.data.result.items.length) {
				this.form.supId = res.data.result.items[0].remoteKey
				this.time = this.today
				this.queryData()
				this.getHasLyConfirm()
			}
		})
	},
	methods: {
		handleShowLYrule() {
			this.lyRuleVisible = true
		},
		handleSetLYrule() {
			let data = {
				path: 'ERP/SetHasLYConfirm',
				parmsJson: { supId: this.form.supId }
			}
			KSAXApiRequest(data).then(res => {
				if (res.data.success) {
					this.hasLYConfirm = true
					this.lyRuleVisible = false
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getHasLyConfirm() {
			let data = {
				path: 'ERP/GetHasLYConfirm',
				parmsJson: { supId: this.form.supId }
			}
			KSAXApiRequest(data).then(res => {
				if (res.data.success) {
					this.hasLYConfirm = res.data.response
				} else {
					this.$message.error(res.data.msg)
				}
				this.LYflag = true
			})
		},
		// announcement1Close() {
		// 	this.announcementVisible1 = false
		// 	localStorage.setItem("announcement1", true)
		// 	if (localStorage.getItem("announcement2") === null) {
		// 		this.announcementVisible2 = true
		// 	}
		// },
		// announcement2Close() {
		// 	this.announcementVisible2 = false
		// 	localStorage.setItem("announcement2", true)
		// },
		announcementClose() {
			this.announcementVisible = false
			localStorage.setItem("announcement", true)
		},
		toDay() {
			this.time = this.today
			this.queryData()
		},
		toMonth() {
			this.time = this.month
			this.queryData()
		},
		queryData() {
			setTimeout(() => {
				this.form.pageIndex = 1
				this.form.pageSize = 10
				this.form.typeId = 0
				this.loading = true
				this.loadingCount = 0
				this.saleForm = JSON.parse(JSON.stringify(this.form))
				this.saleForm.pageSize = 20
				this.getSupGmv()
				this.getUnShipmentCount()
				this.getSaleSpuCount()
				this.getAfterCount()
				this.getProductViewCount()
				this.getProductTypeCount()
				this.getShipRankingList()
			}, 300)
		},
		getSupGmv() {
			let data = {
				path: 'ERPData/GetSupGmv',
				parmsJson: this.form
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.supGmv = res.data.response
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getUnShipmentCount() {
			let data = {
				path: 'ERPData/UnShipmentCount',
				parmsJson: this.form
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.unShipmentCount = res.data.response
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getSaleSpuCount() {
			let data = {
				path: 'ERPData/SaleSpuCount',
				parmsJson: this.form
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.saleSpuCount = res.data.response
					this.saleSpuCount.list.forEach(item => {
						item.datetime = item.datetime.split(" ")[0]
					})
					const chartDom1 = this.$refs.echarts1;
					const myChart1 = echarts.init(chartDom1);
					const option1 = {
						// title: {
						// 	show: true,
						// 	text: "*此趋势图为近31天的销售数据",
						// 	textStyle: {
						// 		color: "red",
						// 		fontStyle: "italic",
						// 		fontWeight: "lighter",
						// 		fontSize: "12"
						// 	}
						// },
						grid: {
							top: 30,
							left: 0,
							right: 0,
							bottom: 0,
							containLabel: true
						},
						tooltip: {
							trigger: 'axis'
						},
						xAxis: {
							type: 'category',
							data: this.saleSpuCount.list.map(item => {
								return item.datetime
							}),

							// splitLine: {
							// 	show: false
							// }, //去除网格线                
							// splitArea: {
							// 	show: true
							// }, //保留网格区域                
							axisLine: {
								lineStyle: {
									type: 'solid',
									color: '#E9EAED', //左边线的颜色                        
									width: 2 //坐标线的宽度                    
								}
							},
							axisLabel: {
								textStyle: {
									color: '#798993', //坐标值得具体的颜色
								}
							}
						},
						yAxis: {
							type: 'value',
							splitLine: {
								lineStyle: {
									type: 'dashed',
								}
							},
							axisLine: {
								lineStyle: {
									type: 'dashed',
									color: '#E9EAED',
									width: 0
								}
							},
							axisLabel: {
								textStyle: {
									color: '#798993'
								}
							}
						},
						series: [{
							data: this.saleSpuCount.list.map(item => {
								return item.amount
							}),
							type: 'line',
							smooth: true,
							symbolSize: 10, //折线点的大小
							itemStyle: {
								normal: {
									color: '#4c78fe',
									borderColor: '#4c78fe',
								},
							},
							lineStyle: {
								normal: {
									width: 4
								},
							},
							areaStyle: {
								normal: {
									// 添加渐变阴影
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
										{ offset: 0, color: "#4f70ffba", },
										{ offset: 1, color: "#fff", },
									]),
								}
							},
						}]
					};
					myChart1 && myChart1.setOption(option1);
					const chartDom2 = this.$refs.echarts2;
					const myChart2 = echarts.init(chartDom2);
					const option2 = {
						grid: {
							top: 30,
							left: 10,
							right: 0,
							bottom: 0,
							containLabel: true
						},
						tooltip: {
							trigger: 'axis'
						},
						xAxis: {
							type: 'category',
							data: this.saleSpuCount.list.map(item => {
								return item.datetime
							}),
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								lineStyle: {
									type: 'solid',
									color: '#E9EAED', //左边线的颜色                        
									width: 2 //坐标线的宽度                    
								}
							},
							axisLabel: {
								textStyle: {
									color: '#798993', //坐标值得具体的颜色
								}
							}
						},
						yAxis: {
							type: 'value',
							splitLine: {
								lineStyle: {
									type: 'dashed',
								}
							},
							axisLine: {
								lineStyle: {
									type: 'dashed',
									color: '#E9EAED',
									width: 0
								}
							},
							axisLabel: {
								textStyle: {
									color: '#798993'
								}
							}
						},
						series: [{
							data: this.saleSpuCount.list.map(item => {
								return item.spuCount
							}),
							name: '数量',
							type: 'bar',
							barWidth: '40%',
							itemStyle: {
								normal: {
									color: '#F74644',
								}
							},
						}]
					};
					myChart2 && myChart2.setOption(option2);
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getShipRankingList() {
			let data = {
				path: 'ERPData/ShipRankingList',
				parmsJson: {
					...this.form,
					startTime: this.$moment().subtract(this.shipRankingListTimeType, 'days').format('YYYY-MM-DD'),
					endTime: this.$moment().add(1, 'd').format('YYYY-MM-DD'),
				}
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.shipRankingList = { ...res.data.response, timeIn2448CountRate: this.shipRankingListTimeType === 7 ? res.data.response.timeIn2448CountRate : this.shipRankingList.timeIn2448CountRate }
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getAfterCount() {
			let data = {
				path: 'ERPData/AfterCount',
				parmsJson: {
					...this.form,
					startTime: this.$moment().subtract(this.allAfterTimeType, 'days').format('YYYY-MM-DD'),
					endTime: this.$moment().add(1, 'd').format('YYYY-MM-DD'),
				}
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.afterCount = res.data.response
					if (this.afterCount.allAfterCountRate < 0) {
						this.afterCount.allAfterCountRate = 0
					}
					if (this.afterCount.otherAfterCountRate < 0) {
						this.afterCount.otherAfterCountRate = 0
					}
					if (this.afterCount.userAfterCountRate < 0) {
						this.afterCount.userAfterCountRate = 0
					}
					// // 3
					// const chartDom3 = this.$refs.echarts3;
					// const myChart3 = echarts.init(chartDom3);
					// const option3 = {
					// 	series: [
					// 		{
					// 			type: 'gauge',
					// 			center: ['50%', '75%'],
					// 			radius: '100%',  //半径
					// 			startAngle: 180,
					// 			endAngle: 0,
					// 			splitNumber: 5,
					// 			min: 0,
					// 			max: 100,
					// 			'axisLine': {
					// 				'show': true,
					// 				'lineStyle': {
					// 					'color': [
					// 						[this.afterCount.allAfterCountRate / 100, "rgb(88 217 249)"],
					// 						[1, 'rgb(230 235 248)']
					// 					],
					// 					'width': 10
					// 				}
					// 			},
					// 			detail: {
					// 				show: false
					// 			},
					// 			// 图表的指针
					// 			'pointer': {
					// 				length: '60%',
					// 				width: 5,
					// 			},
					// 			data: [{ value: this.afterCount.allAfterCountRate }]
					// 		}
					// 	]
					// };
					// option3 && myChart3.setOption(option3);
					// // 4
					// const chartDom4 = this.$refs.echarts4;
					// const myChart4 = echarts.init(chartDom4);
					// const option4 = {
					// 	series: [
					// 		{
					// 			type: 'gauge',
					// 			center: ['50%', '50%'],
					// 			radius: '100%',  //半径
					// 			startAngle: 180,
					// 			endAngle: 0,
					// 			splitNumber: 5,
					// 			min: 0,
					// 			max: 100,
					// 			'axisLine': {
					// 				'show': true,
					// 				'lineStyle': {
					// 					'color': [
					// 						[this.afterCount.userAfterCountRate / 100, "rgb(88 217 249)"],
					// 						[1, 'rgb(230 235 248)']
					// 					],
					// 					'width': 10
					// 				}
					// 			},
					// 			detail: {
					// 				'offsetCenter': ["0%", "50%"],
					// 				formatter: function (value) {
					// 					return `主动退货率${value}%`
					// 				},
					// 				fontSize: 20,
					// 			},
					// 			// 图表的指针
					// 			'pointer': {
					// 				length: '60%',
					// 				width: 5,
					// 			},
					// 			data: [{ value: this.afterCount.userAfterCountRate }]
					// 		}
					// 	]
					// };
					// option4 && myChart4.setOption(option4);
					// // 5
					// const chartDom5 = this.$refs.echarts5;
					// const myChart5 = echarts.init(chartDom5);
					// const option5 = {
					// 	series: [
					// 		{
					// 			type: 'gauge',
					// 			center: ['50%', '50%'],
					// 			radius: '100%',  //半径
					// 			startAngle: 180,
					// 			endAngle: 0,
					// 			splitNumber: 5,
					// 			min: 0,
					// 			max: 100,
					// 			'axisLine': {
					// 				'show': true,
					// 				'lineStyle': {
					// 					'color': [
					// 						[this.afterCount.otherAfterCountRate / 100, "rgb(88 217 249)"],
					// 						[1, 'rgb(230 235 248)']
					// 					],
					// 					'width': 10
					// 				}
					// 			},
					// 			detail: {
					// 				'offsetCenter': ["0%", "50%"],
					// 				formatter: function (value) {
					// 					return `非客户原因退货率${value}%`
					// 				},
					// 				fontSize: 20,
					// 			},
					// 			// 图表的指针
					// 			'pointer': {
					// 				length: '60%',
					// 				width: 5,
					// 			},
					// 			data: [{ value: this.afterCount.otherAfterCountRate }]
					// 		}
					// 	]
					// };
					// option4 && myChart5.setOption(option5);
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getProductViewCount() {
			let data = {
				path: 'ERPData/ProductViewCount',
				parmsJson: this.form
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.productViewCount = res.data.response
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getProductTypeCount() {
			let data = {
				path: 'ERPData/ProductTypeCount',
				parmsJson: this.form
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.productTypeCount = res.data.response
					this.productTypeCount.typeList.unshift({
						typeId: 0,
						typeName: "全部"
					})
					this.getProductSpuPankErpCount()
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		getProductSpuPankErpCount() {
			let data = {
				path: 'ERPData/ProductSpuPankErpCount',
				parmsJson: this.saleForm
			}
			KSAXApiRequest(data).then(res => {
				this.loadingCount += 1
				if (res.data.success) {
					this.productSpuPankErpCount = res.data.response
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		typeClick(item) {
			this.saleForm.typeId = item.typeId
			this.saleForm.pageIndex = 1
			this.getProductSpuPankErpCount()
		},
		goOrder(value) {
			this.$router.push("/OrderManagement/SubOrder?unShipType=" + value)
		},
		goAfterSale() {
			this.$router.push("/AfterSalesService/AfterSaleList/Index1")
		},
		goOnSaleProduct() {
			this.$router.push("/Product/SpuOnSale")
		},
		goProductDetail(row) {
			this.$router.push(`/Product/AddEditSpu?id=${row.spuId}`)
		},
		handleSizeChange(value) {
			this.form.pageSize = value
			this.getProductViewCount()
		},
		handleCurrentChange(value) {
			this.form.pageIndex = value
			this.getProductViewCount()
		},
		handleSaleSizeChange(value) {
			this.saleForm.pageSize = value
			this.getProductSpuPankErpCount()
		},
		handleSaleCurrentChange(value) {
			this.saleForm.pageIndex = value
			this.getProductSpuPankErpCount()
		},
		rowStyle({ row, rowIndex }) {
			if (rowIndex % 2 !== 0) {
				return { "background": "#F0F4FC" }
			}
		}
	}
}
</script>

<style scoped>
.p {
	text-indent: 2em;
	margin-top: 10px;
}

.p2 p,
b {
	text-indent: 2em;
	margin-top: 10px;
	font-size: 16px;
}

.p2 b {
	color: black;
}

.textR {
	text-align: right;
}

.textC {
	text-align: center;
}

.red {
	color: red;
}

.el-row {
	display: flex;
}

.el-row .el-card {
	height: 100%;
}

.pointer {
	cursor: pointer;
}

.time {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #666666;
}

.number {
	font-family: PingFangSC, PingFang SC;
	font-weight: 500;
	font-size: 32px;
	color: #191D21;
}

.rate {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #F82339;
}

.msg {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #F82339;
}

.page {
	background: #F5F9FD;
	padding: 20px;
	margin-top: -20px;
}

.el-card {
	border: none;
	border-radius: 8px;
}

.page>>>.el-card__header {
	border: none;
}

.page>>>.el-card__body {
	padding-top: 0;
}

.card-xse>>>.el-card__header {
	margin: 10px;
	padding: 14px;
	background: linear-gradient(104deg, #E7F7FF 0%, #FFFFFF 100%);
	border-radius: 8px;
}

.card-dxp>>>.el-card__header {
	margin: 10px;
	padding: 14px;
	background: linear-gradient(90deg, rgba(255, 226, 240, 0.29) 0%, #FFFFFF 100%);
	border-radius: 8px;
}

.order1 {
	background: #FFE9D0;
	border-radius: 8px;
}

.order1-p1 {
	background: #FE6804;
	border-radius: 8px 0px 16px 0px;
	display: inline-block;
	font-family: PingFang-SC, PingFang-SC;
	font-weight: bold;
	font-size: 16px;
	color: #FFFFFF;
	padding: 5px 10px;
}

.order1-p2 {
	color: #813100;
}

.order1-p3 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 500;
	font-size: 32px;
	color: #813100;
}

.order2 {
	background: #FFB663;
	border-radius: 8px;
}

.order3 {
	background: #FE6804;
	border-radius: 8px;

}

.order3-p1 {
	background: #FFE2C2;
	border-radius: 8px 0px 16px 0px;
	display: inline-block;
	font-family: PingFang-SC, PingFang-SC;
	font-weight: bold;
	font-size: 16px;
	color: #FE6804;
	padding: 5px 10px;
}

.order3-p2 {
	color: #FFFFFF;
}

.order3-p3 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 500;
	font-size: 32px;
	color: #FFFFFF;
}

.order4 {
	background: #AF4300;
	border-radius: 8px;
}

.allAfter-item {
	padding: 20px;
	background: #F5F9FD;
	border-radius: 8px;
}

.allAfter-item-p1 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 24px;
	color: #666666;
}

.allAfter-item-p2 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 500;
	font-size: 44px;
	color: #191D21;
}

.znfx {
	border-top: 1px solid #DEDEDE;
	padding-top: 20px;
	margin-top: 20px;
}

.znfx-p1 {
	font-family: PingFang-SC, PingFang-SC;
	font-weight: bold;
	font-size: 24px;
	color: #337DFE;
}

.znfx-p2 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #999999;
}

.productView-p1 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #666666;
}

.productView-p2 {
	font-family: PingFangSC, PingFang SC;
	font-weight: 500;
	font-size: 28px;
	color: #191D21;
}

.lyConfirmBtn {
	text-decoration: underline;
	color: red;
	cursor: pointer;
}

.lyConfirmBtn:hover {
	text-decoration: none;
}
</style>
